import React, { SyntheticEvent, useState } from "react";

// Interface
import LoadingSwitch from "react-lib/appcon/common/LoadingSwitch";

import { AggStockSerializer, BUTTON_ACTIONS, RunSequence } from "./sequence/StockManagement";

// Types
type DisplayCountingProps = {
  // seq
  runSequence: RunSequence;
  card: string;
  // data
  data: AggStockSerializer;
  // config
  disabled?: boolean;
};

// Const
const COLORS = {
  blue: "rgb(2 52 150)",
};

const CountingSwitch = (props: DisplayCountingProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleCounting = (e: SyntheticEvent) => {
    handlePrevent(e);

    props.runSequence({
      sequence: "StockManagement",
      action: "COUNTING",
      btnAction: BUTTON_ACTIONS.COUNTING,
      card: props.card,
      errorKey: props.card,
      stock: props.data,
      onLoading: setIsLoading,
    });
  };

  const handlePrevent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return props.data.storage.id ? (
    <LoadingSwitch
      background={COLORS.blue}
      boxStyle={{ justifyContent: "center" }}
      checked={!!props.data.in_reconcile}
      disabled={props.disabled}
      formStyle={{ margin: "0px auto 0 1.5rem", transform: "scale(0.8)" }}
      loaderStyle={{ marginLeft: props.data.in_reconcile ? "29px" : "13px" }}
      loading={isLoading}
      onChange={handleCounting}
    />
  ) : null;
};

export default React.memo(CountingSwitch);
